import styled from "styled-components";
import { FiVideo } from "react-icons/fi";

const JoinLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  max-width: 100%;
  padding: 16px 24px;
  border: 1px solid ${p => p.theme.colors.homeGold};
  border-radius: 8px;
  background: linear-gradient(145deg, rgba(127,205,205,.24), rgba(127,205,205,.06)), #104951;
  box-shadow: inset 0 1px 0 rgba(255,255,255,.22), 0 4px 16px rgba(0,0,0,.16);
  color: ${p => p.theme.colors.homeGold};
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  svg { flex-shrink: 0; }
  &:hover { background-color: #17616b; color: ${p => p.theme.colors.homeGold}; }
  &:focus-visible { outline: 3px solid ${p => p.theme.colors.accent}; outline-offset: 4px; }
`;

export default function MondayZoomLink() {
  return <JoinLink href="https://us02web.zoom.us/j/2897643954?pwd=L2dOSEMzd3F5T0xqZ3lWNnFDSGRFdz09" target="_blank" rel="noopener noreferrer">
    <FiVideo aria-hidden="true" />Join Monday Musicians on Zoom
  </JoinLink>;
}
